<h1 class="mb-4">
  <mdb-icon fas icon="cog"></mdb-icon> Territorios
</h1>
<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Reportes y Consulta</span>
      <span> /</span>
      <span class="grey-text">Ventas</span>
      <span> /</span>
      <span>Territorios</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-body">
        <div class="col d-flex align-items-center " style="max-width: 350px;">
          <!-- Material checked -->
          <div class="form-check">
            <input type="radio" class="form-check-input" id="rbVistaResumen" mdbInput formControlName="tipoVista"
              [value]="RB_TIPO_VISTA_RESUMEN" />
            <label class="form-check-label" for="rbVistaResumen">Vista Resumen</label>
          </div>
          <!-- Material unchecked -->
          <div class="form-check">
            <input type="radio" class="form-check-input" id="rbVistaDetalle" mdbInput formControlName="tipoVista"
              [value]="RB_TIPO_VISTA_DETALLE" />
            <label class="form-check-label" for="rbVistaDetalle">Vista Detallada</label>
          </div>
        </div>
        <div class="col" style="max-width: 200px">
          <div class="md-form mb-0">
            <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" required
              formControlName="fechaDesde"></mdb-date-picker>
            <div *ngIf="
                  formHeader.get('fechaDesde').invalid &&
                  (formHeader.get('fechaDesde').dirty ||
                  formHeader.get('fechaDesde').touched)
                ">
              <mdb-error *ngIf="formHeader.get('fechaDesde').hasError('required')">Ingrese fecha desde
              </mdb-error>
            </div>
          </div>
        </div>
        <div class="col" style="max-width: 200px">
          <div class="md-form mb-0">
            <mdb-date-picker [inline]="true" name="fechaHasta" [placeholder]="'Hasta'" required
              formControlName="fechaHasta"></mdb-date-picker>
            <div *ngIf="
                  formHeader.get('fechaHasta').invalid &&
                  (formHeader.get('fechaHasta').dirty ||
                  formHeader.get('fechaHasta').touched)
                ">
              <mdb-error *ngIf="formHeader.get('fechaHasta').hasError('required')">Ingrese fecha hasta
              </mdb-error>
            </div>
          </div>
        </div>
        <div class="col" style="max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsTerritorio" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Selecione" formControlName="listaTerritorio"></mdb-select>
            <label>Territorio</label>
          </div>
        </div>
      </div>

      <div class="row filtros-body">
        <div *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE" class="col" style="max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsRubro" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Selecione" formControlName="listaRubro"></mdb-select>
            <label>Rubro de Productos</label>
          </div>
        </div>
        <div *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE" class="col" style="max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsFamilia" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Selecione" formControlName="listaFamilia"></mdb-select>
            <label>Familia de Productos</label>
          </div>
        </div>
      </div>

    </div>

    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div class="resultados pl-2"></div>
      <div>
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="LimpiarData()">Limpiar</button>
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
          <mdb-icon fas icon="search"></mdb-icon>
          Buscar
        </button>
      </div>
    </div>
  </div>
</form>

<!-- Listado -->
<div class="card mb-2 wow">
  <div class="card-body p-1 justify-content-between">
    <div *ngIf="resumen_loading || detalle_loading" class="w-100 d-block text-center">
      <mdb-spinner *ngIf="resumen_loading || detalle_loading" spinnerColor="blue"></mdb-spinner>
    </div>
    <div class="table-responsive" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN">
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="resumen_listaMovimientos">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Territorio</th>
            <th scope="col" class="text-right">Monto Neto</th>
            <th scope="col" class="text-right">Descuento</th>
            <th scope="col" class="doble-linea text-right">Total Neto</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let mov of resumen_listaMovimientos">
            <td>{{ mov.nombre }}</td>
            <td class="text-right">{{ mov.monto_neto | numerico }}</td>
            <td class="text-right">{{ mov.descuento | numerico }}</td>
            <td class="text-right">{{ mov.neto_total | numerico }}</td>
          </tr>
        </tbody>
        <!-- TOTALES -->
        <tbody class="blue lighten-5">
          <tr>
            <td class="text-right"><strong>Totales</strong></td>
            <td class="text-right"><strong>$ {{resumen_totales.monto_neto | numerico}}</strong></td>
            <td class="text-right"><strong>$ {{resumen_totales.descuento | numerico}}</strong></td>
            <td class="text-right"><strong>$ {{resumen_totales.neto_total | numerico}}</strong></td>
          </tr>
        </tbody>
        <app-pagination [context]="resumen_paginationContext" (onPageChange)="resumenOnPageChange($event)"
          *ngIf="resumen_listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>

    <div class="table-responsive" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE">
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="detalle_listaMovimientos">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Tipo Doc.</th>
            <th scope="col">Folio</th>
            <th scope="col">Rut</th>
            <th scope="col">Cliente</th>
            <th scope="col">Direccion</th>
            <th scope="col">Comuna</th>
            <th scope="col">Territorio</th>
            <th scope="col" class="text-right">Monto Neto</th>
            <th scope="col" class="text-right">Descuento</th>
            <th scope="col" class="doble-linea text-right">Total Neto</th>
            <!-- <th scope="col">Zona</th> -->

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let mov of detalle_listaMovimientos">
            <td>{{ mov.tipo_dte_nombre }}</td>
            <td>{{ mov.folio | numerico }}</td>
            <td>{{ mov.rutFormato | rut }}</td>
            <td>{{ mov.cliente_proveedor_nombre }}</td>
            <td>{{ mov.direccion_nombre }}</td>
            <td>{{ mov.nombrecomuna }}</td>
            <td>{{ mov.codigo }}</td>
            <td class="text-right">{{ mov.monto_neto | numerico }}</td>
            <td class="text-right">{{ mov.descuento | numerico }}</td>
            <td class="text-right">{{ mov.neto_total | numerico }}</td>
          </tr>
        </tbody>
        <!-- TOTALES -->
        <tbody class="blue lighten-5">
          <tr>
            <td class="text-right" colspan="7"><strong>Totales</strong></td>
            <td class="text-right"><strong>$ {{detalle_totales.monto_neto | numerico}}</strong></td>
            <td class="text-right"><strong>$ {{detalle_totales.descuento | numerico}}</strong></td>
            <td class="text-right"><strong>$ {{detalle_totales.neto_total | numerico}}</strong></td>
          </tr>
        </tbody>
        <app-pagination [context]="detalle_paginationContext" (onPageChange)="detalleOnPageChange($event)"
          *ngIf="detalle_listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>
  </div>
</div>

<div class="card mb-2 wow"
  *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN && resumen_listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="resumenDownloadExcelPdf('XLS')">
      Excel
    </button>
  </div>
</div>
<div class="card mb-2 wow"
  *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE && detalle_listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="detalleDownloadExcelPdf('XLS')">
      Excel
    </button>
  </div>
</div>